module.exports = __webpack_public_path__ + "static/bri-b208bae445b1543b541cf23a56f0dcea.jpg";